import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum } from '@systemeio/ui';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { GOCARDLESS_ACCOUNT_API } from 'modules/profile/payment-gateways/integrations/gocardless/api';
import { GocardlessAuthorizationLinkPayloadInterface, GocardlessCreateIntegrationInterface } from 'modules/profile/payment-gateways/integrations/gocardless/types';
import Router, { useRouter } from 'next/router';
import { useEffect } from 'react';
import { BASE_PATH_URL } from 'shared/constants/base-path-url';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
const getRedirectUrl = (pathname: string) => `${window.location.origin}${BASE_PATH_URL}${pathname}`;
export const useGoCardlessConnect = () => {
  const $ = _c(20);
  const {
    pathname,
    query
  } = useRouter();
  const {
    code: goCardlessConnectCode
  } = query;
  const {
    paymentIntegrations,
    mutatePaymentIntegrations,
    getConnectedPaymentIntegration
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: authFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: connectFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== authFetcher || $[3] !== pathname) {
    t2 = async () => {
      ;
      try {
        const responseData = await authFetcher(`${GOCARDLESS_ACCOUNT_API}/authorization-link`, {
          redirectUrl: getRedirectUrl(pathname)
        } as GocardlessAuthorizationLinkPayloadInterface);
        if (responseData.authenticationUrl) {
          window.open(responseData.authenticationUrl, "_self");
        }
      } catch (t3) {
        const e = t3;
      }
    };
    $[2] = authFetcher;
    $[3] = pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getGoCardlessAuthorizationLink = t2;
  let t3;
  if ($[5] !== connectFetcher || $[6] !== getConnectedPaymentIntegration || $[7] !== goCardlessConnectCode || $[8] !== mutatePaymentIntegrations || $[9] !== pathname || $[10] !== paymentIntegrations) {
    t3 = () => {
      if (!goCardlessConnectCode || !paymentIntegrations) {
        return;
      }
      const gocardlessIntegration = getConnectedPaymentIntegration({
        processor: PaymentProcessorEnum.Gocardless
      });
      const connectGoCardlessAccount = async () => {
        ;
        try {
          await connectFetcher(`${GOCARDLESS_ACCOUNT_API}/create`, {
            authorizationCode: goCardlessConnectCode,
            redirectUrl: getRedirectUrl(pathname)
          } as GocardlessCreateIntegrationInterface);
          await Router.replace({
            pathname
          }, undefined, {
            shallow: true
          });
          await mutatePaymentIntegrations();
        } catch (t4) {
          const e_0 = t4;
        }
      };
      if (!gocardlessIntegration) {
        connectGoCardlessAccount();
      }
    };
    $[5] = connectFetcher;
    $[6] = getConnectedPaymentIntegration;
    $[7] = goCardlessConnectCode;
    $[8] = mutatePaymentIntegrations;
    $[9] = pathname;
    $[10] = paymentIntegrations;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== connectFetcher || $[13] !== goCardlessConnectCode || $[14] !== mutatePaymentIntegrations || $[15] !== pathname || $[16] !== paymentIntegrations) {
    t4 = [connectFetcher, goCardlessConnectCode, mutatePaymentIntegrations, pathname, paymentIntegrations];
    $[12] = connectFetcher;
    $[13] = goCardlessConnectCode;
    $[14] = mutatePaymentIntegrations;
    $[15] = pathname;
    $[16] = paymentIntegrations;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  useEffect(t3, t4);
  let t5;
  if ($[18] !== getGoCardlessAuthorizationLink) {
    t5 = {
      getGoCardlessAuthorizationLink
    };
    $[18] = getGoCardlessAuthorizationLink;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};